import React, { useEffect, useMemo } from "react";
import { NavLink, Outlet, Route, Routes, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import _ from 'lodash';

import Text from "src/components/text";
import Thumbnail from "src/components/thumbnail";

import { ExploreCoaching } from "./explore";
import { StudioPage } from "./studio";
import { Learnings } from "./learnings";
import { ManageCoursesPage } from "./manage";
import { CoachingReports } from "./reports";

import { EditCourseDetailsPage, EditCoursePage } from "./manage/courses/edit";
import { EditCourseStructurePage } from "./manage/courses/edit/structure";

import { ViewCoursePage, ViewCourseStructurePage } from "./learnings/course/view";
import { ViewExploreCoursePage } from "./explore/course/view";  
import { ViewExploreSimulationPage } from "./explore/simulation/view";
import { PreviewCoursePage, PreviewCourseStructurePage } from "./manage/courses/preview";
import { EditSimulationPage } from "./manage/simulations/edit";
import { ViewSimulationPage } from "./learnings/simulation/view";

import {EditSimulationsReportsPage} from "./manage/simulations/reports"
import EditCoursesReportsPage from "./manage/courses/edit/components/reports";
import { PreviewSimulationPage } from "./manage/simulations/preview";
import { EditPodcastPage } from "./manage/podcasts/edit";

import { ViewPodcastPage } from "./learnings/podcast/view";

import { ViewDemoCoursePage, ViewDemoCourseStructurePage } from "./demo/courses";
import { ViewDemoSimulationPage } from "./demo/simulations";

import userRoleService from "src/utils/userRoles.service";
import { getFullName } from "src/utils/utils";

import styles from "./coaching.module.scss";
import { ViewExplorePodcastPage } from "./explore/podcast/view";
import { ViewDemoPodcastPage } from "./demo/podcasts";

const CoachingPage: React.FC<object> = () => {
  return (
    <Routes>
      <Route path="/" element={<CoachingLayoutPage />}>
        <Route path="/explore" Component={ExploreCoaching}></Route>
        <Route path="/studio" Component={StudioPage}></Route>
        <Route path="/courses" Component={Learnings}></Route>
        <Route path="/manage" Component={ManageCoursesPage}></Route>
        <Route path="/reports" Component={CoachingReports}></Route>
      </Route>
      <Route path="/manage/courses/draft/:id" Component={EditCoursePage}>
        <Route path="/manage/courses/draft/:id" Component={EditCourseDetailsPage}></Route>
        <Route path="/manage/courses/draft/:id/contents" Component={EditCourseStructurePage}></Route>
      </Route>

      <Route path="/manage/courses/:id/reports/:learningId" Component={EditCoursesReportsPage}></Route>

      <Route path="/manage/courses/preview/:id" Component={PreviewCoursePage}></Route>
      <Route path="/manage/courses/preview/:id/contents" Component={PreviewCourseStructurePage}></Route>

      <Route path="/courses/:courseId" Component={ViewCoursePage}></Route>
      <Route path="/courses/:id/contents" Component={ViewCourseStructurePage}></Route>

      <Route path="/manage/simulations/draft/:id" Component={EditSimulationPage}></Route>
      <Route path="/manage/simulations/:id/reports/:learningId" Component={EditSimulationsReportsPage}></Route>

      <Route path="/simulations/:id" Component={ViewSimulationPage}></Route>

      <Route path="/explore/courses/:courseId" Component={ViewExploreCoursePage}></Route>
      <Route path="/explore/courses/:id/contents" Component={ViewCourseStructurePage}></Route>
      <Route path="/explore/simulations/:id" Component={ViewExploreSimulationPage}></Route>
      <Route path="/explore/podcasts/:id" Component={ViewExplorePodcastPage}></Route>

      <Route path="/manage/podcasts/draft/:id" Component={EditPodcastPage}></Route>
      <Route path="/podcasts/:id" Component={ViewPodcastPage}></Route>

      <Route path="/demo/courses/:courseId" Component={ViewDemoCoursePage}></Route>
      <Route path="/demo/courses/:id/contents" Component={ViewDemoCourseStructurePage}></Route>
      <Route path="/demo/simulations/:id" Component={ViewDemoSimulationPage}></Route>
      <Route path="/demo/podcasts/:id" Component={ViewDemoPodcastPage}></Route>
    </Routes>
  );
};

const CoachingLayoutPage: React.FC<object> = () => {
  const user = useSelector((state: any) => {
    return _.get(state, 'users.me');
  });

  const navigate = useNavigate();
  const location = useLocation();
  const pathName = location.pathname

  const getType = (type: string) => {
    switch (type) {
      case "/explore":
        return "explore";
      case "/studio":
        return "studio";
      case "/courses":
        return "my courses";
      case "/manage":
        return "manage";
      case "/reports":
        return "reports";
      default:
        return "explore";
    }
  };

  const getCurrentPage = () => {
    const path = pathName.split('/coaching');
    var type = path[1];
    return getType(type);
  };

  useEffect(() => {
    if(pathName === "/coaching") {
      navigate('/coaching/explore');
    }
  }, [location]);

  return (
    <>
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.logo}>
            <img src="/images/coaching/hey-logo.svg" alt="Coaching" />
            <span>/{getCurrentPage()}</span>
          </div>
        </div>

        <Outlet />
      </div>
    </>
  );
};

export { CoachingPage };
